import React from 'react';
import ReactDOM from 'react-dom';

interface CreateFolderModalProps {
  folderName: string;
  onFolderNameChange: (name: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Modal dialog for creating a new folder in the file browser.
 */
const CreateFolderModal: React.FC<CreateFolderModalProps> = ({
  folderName,
  onFolderNameChange,
  onConfirm,
  onCancel,
}) => ReactDOM.createPortal(
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-xl max-w-md w-full p-6 shadow-xl">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Create New Folder</h3>
        <button onClick={onCancel} className="text-gray-400 hover:text-gray-600" aria-label="Close">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div className="space-y-4">
        <div>
          <label htmlFor="create-folder-name" className="block text-sm font-medium text-gray-700 mb-2">
            Folder Name
          </label>
          <input
            id="create-folder-name"
            type="text"
            value={folderName}
            onChange={(e) => onFolderNameChange(e.target.value)}
            placeholder="Enter folder name"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            onKeyPress={(e) => e.key === 'Enter' && onConfirm()}
            autoFocus
          />
        </div>
        <div className="flex space-x-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={!folderName.trim()}
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Create Folder
          </button>
        </div>
      </div>
    </div>
  </div>
, document.body);

export default CreateFolderModal;
